/* ============================================================
   PARTPOINT.GE — assets/facets.js  v3 · FILTERS v1 (2026-09-24)
   ------------------------------------------------------------
   snippets/facets.liquid-ის (pp-f) ქცევა. v2-ის დაცვები შენარჩუნებულია:
     • section rendering (?section_id=) — გვერდი არ იტვირთება თავიდან;
     • მოთხოვნის გაუქმება: ახალი ცვლილება წინა fetch-ს AbortController-ით წყვეტს,
       ძველი პასუხი requestId-ით იგნორდება (#29/#30);
     • ქეში — ბოლო 10 პასუხი (#36); history.pushState / popstate; `pp:filters-updated`;
     • PriceRange-ის ნორმალიზაცია (#38).
   ახალი:
     • ფილტრი მაშინვე ვრცელდება (checkbox/select 120 ms, ფასი 700 ms / change-ზე);
     • URL იცვლება მხოლოდ წარმატებული პასუხის შემდეგ; ფილტრის ცვლილება `page`-ს შლის;
       მოძველებული ?page=N (ცარიელი გვერდი, მაგრამ შედეგი არსებობს) → პირველ გვერდზე;
     • ქვედა ფურცელი: focus trap, Escape, focus-ის დაბრუნება, სქროლის ჩაკეტვა, ფონის
       ქვედა ნავიგაცია/AI ჩატი იმალება, „აჩვენე N პროდუქტი“ ხურავს და შედეგებზე აბრუნებს;
     • desktop პანელები: ერთდროულად ერთი, Escape/გარე დაწკაპება ხურავს, ეკრანს არ სცდება;
     • ეკრანის წამკითხველს რაოდენობა ცოცხალ რეგიონში ეუწყება (#pp-f-live);
     • შეცდომისას — ხილული შეტყობინება და „თავიდან ცდა“ (სრული ჩატვირთვა იმავე URL-ით).
   ============================================================ */
(function () {
  'use strict';

  if (window.customElements && customElements.get('facet-filters-form')) return;

  var doc = document;
  var root = doc.documentElement;
  root.classList.add('pp-f-js');

  var ROOT_ID = 'pp-f';
  var CACHE_MAX = 10;
  var DEBOUNCE_TOGGLE = 120;
  var DEBOUNCE_TEXT = 700;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var state = {
    requestId: 0,
    controller: null,
    cache: [],
    timer: null,
    pendingForm: null,
    drawerOpen: false,
  };

  function $(id) {
    return doc.getElementById(id);
  }

  function getRoot() {
    return $(ROOT_ID);
  }

  function getSectionId() {
    var grid = $('product-grid');
    return grid && grid.dataset ? grid.dataset.id || '' : '';
  }

  /* ---------- URL / params ---------- */

  /* ფასი: „1 200“, „1,200“, „12,5“ → 1200 / 1200 / 12.5 ('' თუ ციფრი არ არის) */
  function normalizePrice(value) {
    var raw = String(value == null ? '' : value).replace(/[\s'’]/g, '');
    if (raw.indexOf(',') !== -1) {
      raw = /^\d{1,3}(,\d{3})+(\.\d+)?$/.test(raw) ? raw.replace(/,/g, '') : raw.replace(/,/g, '.');
    }
    raw = raw.replace(/[^\d.]/g, '');
    var dot = raw.indexOf('.');
    if (dot !== -1) raw = raw.slice(0, dot + 1) + raw.slice(dot + 1).replace(/\./g, '');
    if (raw === '' || raw === '.') return '';
    var num = Number(raw);
    return isFinite(num) ? String(num) : '';
  }

  function paramsFromForm(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function (value, key) {
      if (typeof value !== 'string') return;
      if (/^filter\.v\.price\./.test(key)) {
        value = normalizePrice(value);
        /* ცარიელი ფასის ველი URL-ს არ ამძიმებს */
        if (value === '') return;
      }
      params.append(key, value);
    });
    params.delete('page');
    return params.toString();
  }

  function paramsFromHref(href) {
    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return null;
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      return { path: url.pathname, params: url.searchParams.toString() };
    } catch (e) {
      return null;
    }
  }

  function pageUrl(params, path) {
    return (path || window.location.pathname) + (params ? '?' + params : '');
  }

  /* ---------- რენდერი ---------- */

  function setLoading(on) {
    var r = getRoot();
    if (r) r.classList.toggle('is-loading', on);
    var grid = $('ProductGridContainer');
    if (grid) {
      if (on) grid.setAttribute('aria-busy', 'true');
      else grid.removeAttribute('aria-busy');
      var collection = grid.querySelector('.collection');
      if (collection) collection.classList.toggle('loading', on);
    }
  }

  function showError(fullUrl) {
    var box = $('pp-f-error');
    if (!box) {
      window.location.assign(fullUrl);
      return;
    }
    box.hidden = false;
    box.dataset.url = fullUrl;
  }

  function hideError() {
    var box = $('pp-f-error');
    if (box) box.hidden = true;
  }

  function announce() {
    var live = $('pp-f-live');
    var r = getRoot();
    if (!live || !r) return;
    var source = r.querySelector('[data-pp-f-count]');
    var text = source ? source.textContent.replace(/\s+/g, ' ').trim() : '';
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = text;
    }, 60);
  }

  function captureUiState(r) {
    var s = { open: [], focusId: null, sel: null, scroll: {}, focusCtx: null };
    r.querySelectorAll('details[open][id]').forEach(function (d) {
      /* ფურცელს ცალკე ვმართავთ (drawerOpen) — იხურება თუ არა, ამას აქ არ ვაბრუნებთ */
      if (d.id !== 'pp-f-drawer') s.open.push(d.id);
    });
    r.querySelectorAll('[data-pp-f-scroll], .pp-f__panel').forEach(function (el) {
      var key = el.id || (el.hasAttribute('data-pp-f-scroll') ? 'sheet-body' : '');
      if (key) s.scroll[key] = el.scrollTop;
    });
    var active = doc.activeElement;
    if (active && r.contains(active)) {
      if (active.id) s.focusId = active.id;
      if (active.closest('#pp-f-sheet')) s.focusCtx = 'sheet';
      else if (active.closest('details[data-pp-f-pop]')) s.focusCtx = 'pop:' + active.closest('details[data-pp-f-pop]').id;
      else if (active.closest('.pp-f__chips')) s.focusCtx = 'chips';
      else s.focusCtx = 'bar';
      if (typeof active.selectionStart === 'number' && active.type === 'text') {
        s.sel = [active.selectionStart, active.selectionEnd];
      }
    }
    return s;
  }

  function isVisible(el) {
    return Boolean(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }

  function firstVisible(list) {
    for (var i = 0; i < list.length; i++) if (isVisible(list[i])) return list[i];
    return null;
  }

  function restoreUiState(r, s, drawerOpen) {
    s.open.forEach(function (id) {
      var d = $(id);
      if (d && r.contains(d) && d.tagName === 'DETAILS') {
        /* ხელახლა ჩასმული პანელი ანიმაციას აღარ იმეორებს და იმავე მხარეს რჩება */
        if (d.hasAttribute('data-pp-f-pop')) d.dataset.ppRestored = '1';
        d.open = true;
        if (d.hasAttribute('data-pp-f-pop')) placePanel(d);
      }
    });
    var drawer = $('pp-f-drawer');
    if (drawer && drawerOpen) {
      r.classList.add('pp-f--drawer-shown');
      drawer.open = true;
      syncExpanded(drawer);
    }
    r.querySelectorAll('details[data-pp-f-pop]').forEach(syncExpanded);
    Object.keys(s.scroll).forEach(function (key) {
      var el = key === 'sheet-body' ? r.querySelector('[data-pp-f-scroll]') : $(key);
      if (el) el.scrollTop = s.scroll[key];
    });

    var target = s.focusId ? $(s.focusId) : null;
    if (target && (target.disabled || !r.contains(target) || !isVisible(target))) target = null;
    if (!target && s.focusCtx) {
      /* ფოკუსირებული ელემენტი (მაგ. მოხსნილი ჩიპი ან „გასუფთავება“) აღარ არსებობს — უახლოესი ხილული */
      if (s.focusCtx === 'sheet' && drawerOpen) {
        target = r.querySelector('.pp-f__sheet .pp-f__x');
      } else if (s.focusCtx.indexOf('pop:') === 0) {
        var pop = $(s.focusCtx.slice(4));
        target = pop ? pop.querySelector(':scope > summary') : null;
      } else if (s.focusCtx === 'chips') {
        target = firstVisible(r.querySelectorAll('.pp-f__chip, #pp-f-clear-all'));
      }
      if (!target || !isVisible(target)) target = firstVisible(r.querySelectorAll('#pp-f-open, .pp-f__pill, #pp-f-sort-m, #pp-f-sort-d'));
    }
    if (target && typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (e) {
        target.focus();
      }
      if (s.sel && typeof target.setSelectionRange === 'function') {
        try {
          target.setSelectionRange(s.sel[0], s.sel[1]);
        } catch (e) {
          /* not a text field any more */
        }
      }
    }
  }

  function renderFromHtml(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');

    /* ფილტრის ბლოკი — შიგთავსი იცვლება, თავად #pp-f (და ცოცხალი რეგიონი მის გარეთ) რჩება */
    var current = getRoot();
    var incoming = parsed.getElementById(ROOT_ID);
    if (current && incoming) {
      var drawer = $('pp-f-drawer');
      var drawerOpen = Boolean(drawer && drawer.open && !drawer.classList.contains('is-closing'));
      var ui = captureUiState(current);
      current.innerHTML = incoming.innerHTML;
      ['data-pp-total', 'data-pp-active', 'data-pp-stale'].forEach(function (name) {
        if (incoming.hasAttribute(name)) current.setAttribute(name, incoming.getAttribute(name));
        else current.removeAttribute(name);
      });
      restoreUiState(current, ui, drawerOpen);
    }

    /* პროდუქტების ბადე */
    var grid = $('ProductGridContainer');
    var gridIncoming = parsed.getElementById('ProductGridContainer');
    if (grid && gridIncoming) {
      grid.innerHTML = gridIncoming.innerHTML;
      grid.querySelectorAll('.scroll-trigger').forEach(function (el) {
        el.classList.add('scroll-trigger--cancel');
      });
    }
    if (typeof window.initializeScrollAnimationTrigger === 'function') {
      try {
        window.initializeScrollAnimationTrigger();
      } catch (e) {
        /* optional */
      }
    }
  }

  function cacheGet(url) {
    for (var i = 0; i < state.cache.length; i++) {
      if (state.cache[i].url === url) return state.cache[i].html;
    }
    return null;
  }

  function cachePut(url, html) {
    state.cache = state.cache.filter(function (entry) {
      return entry.url !== url;
    });
    state.cache.push({ url: url, html: html });
    while (state.cache.length > CACHE_MAX) state.cache.shift();
  }

  /**
   * @param {string} params  query string (without '?')
   * @param {{push?: boolean, path?: string}} [opts]
   */
  function renderPage(params, opts) {
    opts = opts || {};
    var push = opts.push !== false;
    var path = opts.path || window.location.pathname;
    params = params || '';
    var sectionId = getSectionId();
    var fullUrl = pageUrl(params, path);
    if (!sectionId || path !== window.location.pathname) {
      window.location.assign(fullUrl);
      return;
    }

    var requestId = ++state.requestId;
    if (state.controller) state.controller.abort();
    state.controller = null;
    hideError();
    setLoading(true);
    FacetFiltersForm.toggleActiveFacets(true);

    var fetchUrl = path + '?section_id=' + encodeURIComponent(sectionId) + (params ? '&' + params : '');

    var finish = function (html) {
      if (requestId !== state.requestId) return;
      /* მომხმარებელმა პასუხის მოლოდინში ახალი ცვლილება გააკეთა (debounce ჯერ არ გასულა):
         ძველ პასუხს აღარ ვხატავთ — ის ფორმას თავიდან დაწერდა და ახალ არჩევანს წაშლიდა */
      if (state.timer && state.pendingForm && state.pendingForm.isConnected) {
        flushPending();
        return;
      }
      renderFromHtml(html);
      setLoading(false);
      FacetFiltersForm.toggleActiveFacets(false);
      FacetFiltersForm.searchParamsPrev = params;
      if (push && pageUrl(params, path) !== window.location.pathname + window.location.search) {
        history.pushState({ searchParams: params }, '', fullUrl);
      }
      doc.dispatchEvent(new CustomEvent('pp:filters-updated', { detail: { params: params } }));
      announce();
    };

    var cached = cacheGet(fetchUrl);
    if (cached) {
      finish(cached);
      return;
    }

    var controller = 'AbortController' in window ? new AbortController() : null;
    state.controller = controller;
    fetch(fetchUrl, controller ? { signal: controller.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        cachePut(fetchUrl, html);
        finish(html);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (requestId !== state.requestId) return;
        console.error('[facets] render failed', error);
        setLoading(false);
        FacetFiltersForm.toggleActiveFacets(false);
        revertForms();
        /* ფურცელი იხურება, რომ შეცდომის შეტყობინება და „თავიდან ცდა“ ჩანდეს */
        closeDrawer(false);
        showError(fullUrl);
      });
  }

  /* ---------- ფორმები ---------- */

  /* შეცდომისას ველები ბოლო წარმატებულ (სერვერის მიერ დახატულ) მდგომარეობას უბრუნდება —
     მონიშნული checkbox და ბადე ერთმანეთს არ ეწინააღმდეგება */
  function revertForms() {
    var r = getRoot();
    if (!r) return;
    window.clearTimeout(state.timer);
    state.timer = null;
    state.pendingForm = null;
    r.querySelectorAll('form').forEach(function (form) {
      form.reset();
    });
    r.querySelectorAll('.pp-f__opt').forEach(function (label) {
      var input = label.querySelector('.pp-f__cb');
      if (input) label.classList.toggle('is-on', input.checked);
    });
  }

  function flushPending() {
    if (!state.timer) return false;
    window.clearTimeout(state.timer);
    state.timer = null;
    var form = state.pendingForm;
    state.pendingForm = null;
    if (form && form.isConnected) {
      renderPage(paramsFromForm(form));
      return true;
    }
    return false;
  }

  function schedule(form, delay) {
    window.clearTimeout(state.timer);
    state.pendingForm = form;
    state.timer = window.setTimeout(function () {
      state.timer = null;
      state.pendingForm = null;
      if (form.isConnected) renderPage(paramsFromForm(form));
    }, delay);
  }

  function isTextField(el) {
    return el && el.tagName === 'INPUT' && (el.type === 'text' || el.type === 'number');
  }

  function onFormEvent(event) {
    var target = event.target;
    var form = target && target.form;
    if (!form || !form.closest('#' + ROOT_ID)) return;

    if (target.type === 'checkbox') {
      /* ერთარჩევნიანი ვირტუალური ჯგუფი (პოზიცია/მხარე) — მეზობელი მოიხსნება */
      var group = target.getAttribute('data-pp-f-excl');
      if (group && target.checked) {
        form.querySelectorAll('input[data-pp-f-excl="' + group + '"]').forEach(function (other) {
          if (other !== target && other.checked) {
            other.checked = false;
            var otherLabel = other.closest('.pp-f__opt');
            if (otherLabel) otherLabel.classList.remove('is-on');
          }
        });
      }
      var label = target.closest('.pp-f__opt');
      if (label) label.classList.toggle('is-on', target.checked);
    }

    if (isTextField(target)) {
      if (event.type === 'input') schedule(form, DEBOUNCE_TEXT);
      else schedule(form, 0);
      return;
    }
    schedule(form, DEBOUNCE_TOGGLE);
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('#' + ROOT_ID)) return;
    event.preventDefault();
    var submitter = event.submitter;
    var isApply = submitter ? submitter.hasAttribute('data-pp-f-apply') : form.id === 'FacetFiltersFormMobile';
    var price = form.querySelectorAll('price-range input');
    price.forEach(function (input) {
      PriceRange.normalize(input);
    });

    if (isApply) {
      /* დაგროვილი ცვლილება ახლავე იგზავნება; ფურცელი იხურება — თუ პასუხი ჯერ მოდის,
         ბადე მზადყოფნისას განახლდება (ფილტრი უკვე ცოცხლად ვრცელდება) */
      flushPending();
      closeDrawer(true);
      return;
    }
    window.clearTimeout(state.timer);
    state.timer = null;
    renderPage(paramsFromForm(form));
  }

  /* ---------- ქვედა ფურცელი (mobile) ---------- */

  function syncExpanded(details) {
    var summary = details && details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      ),
      function (el) {
        return el.offsetParent !== null || el === doc.activeElement;
      }
    );
  }

  function onDrawerToggle(drawer) {
    syncExpanded(drawer);
    var r = getRoot();
    if (drawer.open) {
      /* ხელახალი რენდერის შემდეგ ფურცელი უკვე ღიაა — ფოკუსს აღარ ვეხებით */
      if (state.drawerOpen) return;
      state.drawerOpen = true;
      root.classList.add('pp-f-lock');
      var sheet = drawer.querySelector('.pp-f__sheet');
      var close = drawer.querySelector('.pp-f__x');
      window.setTimeout(
        function () {
          if (r) r.classList.add('pp-f--drawer-shown');
        },
        reduceMotion ? 0 : 340
      );
      if (close) {
        try {
          close.focus({ preventScroll: true });
        } catch (e) {
          close.focus();
        }
      } else if (sheet) {
        sheet.setAttribute('tabindex', '-1');
        sheet.focus();
      }
    } else {
      /* ხელახალი რენდერისას ძველი ელემენტი DOM-იდან ქრება — მისი „დახურვა“ ფურცელს არ ხურავს */
      if (!drawer.isConnected) return;
      state.drawerOpen = false;
      drawer.classList.remove('is-closing');
      root.classList.remove('pp-f-lock');
      if (r) r.classList.remove('pp-f--drawer-shown');
    }
  }

  function closeDrawer(toResults) {
    var drawer = $('pp-f-drawer');
    if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;
    var finish = function () {
      drawer = $('pp-f-drawer') || drawer;
      state.drawerOpen = false;
      drawer.classList.remove('is-closing');
      drawer.open = false;
      syncExpanded(drawer);
      root.classList.remove('pp-f-lock');
      var r = getRoot();
      if (r) r.classList.remove('pp-f--drawer-shown');
      var opener = $('pp-f-open');
      if (toResults) {
        scrollToResults();
        var heading = opener;
        if (heading) {
          try {
            heading.focus({ preventScroll: true });
          } catch (e) {
            heading.focus();
          }
        }
      } else if (opener) {
        opener.focus();
      }
    };
    if (reduceMotion) {
      finish();
      return;
    }
    drawer.classList.add('is-closing');
    var r = getRoot();
    if (r) r.classList.remove('pp-f--drawer-shown');
    window.setTimeout(finish, 220);
  }

  function scrollToResults() {
    var r = getRoot();
    if (!r) return;
    var headerOffset = parseInt(getComputedStyle(root).getPropertyValue('--header-height'), 10) || 0;
    var top = r.getBoundingClientRect().top + window.pageYOffset - headerOffset - 12;
    if (window.pageYOffset > top + 40) {
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  function trapTab(event, drawer) {
    var sheet = drawer.querySelector('.pp-f__sheet');
    if (!sheet) return;
    var items = focusables(sheet);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = doc.activeElement;
    if (!sheet.contains(active)) {
      event.preventDefault();
      first.focus();
      return;
    }
    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------- desktop პანელები ---------- */

  function closePopovers(except) {
    doc.querySelectorAll('#' + ROOT_ID + ' details[data-pp-f-pop][open]').forEach(function (d) {
      if (d === except) return;
      d.open = false;
      syncExpanded(d);
    });
  }

  function placePanel(details) {
    details.classList.remove('is-right');
    var panel = details.querySelector('.pp-f__panel');
    if (!panel) return;
    var rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth - 12) details.classList.add('is-right');
  }

  function onPopoverToggle(details) {
    syncExpanded(details);
    if (!details.open) {
      details.classList.remove('pp-f-anim');
      return;
    }
    if (details.dataset.ppRestored) {
      delete details.dataset.ppRestored;
    } else {
      details.classList.add('pp-f-anim');
    }
    closePopovers(details);
    placePanel(details);
  }

  /* ---------- მოვლენები (ერთხელ, delegation) ---------- */

  function bindGlobal() {
    doc.addEventListener('input', onFormEvent);
    doc.addEventListener('change', onFormEvent);
    doc.addEventListener('submit', onSubmit);

    doc.addEventListener(
      'toggle',
      function (event) {
        var details = event.target;
        if (!details || details.tagName !== 'DETAILS') return;
        if (details.id === 'pp-f-drawer') onDrawerToggle(details);
        else if (details.hasAttribute('data-pp-f-pop')) onPopoverToggle(details);
      },
      true
    );

    doc.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var close = target.closest('[data-pp-f-close]');
      if (close) {
        event.preventDefault();
        closeDrawer(false);
        return;
      }

      var retry = target.closest('[data-pp-f-retry]');
      if (retry) {
        var box = $('pp-f-error');
        window.location.assign((box && box.dataset.url) || window.location.href);
        return;
      }

      var removeLink = target.closest('facet-remove a');
      if (removeLink && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        var next = paramsFromHref(removeLink.href);
        if (!next) return;
        event.preventDefault();
        window.clearTimeout(state.timer);
        state.timer = null;
        renderPage(next.params, { path: next.path });
      }
    });

    doc.addEventListener('pointerdown', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('details[data-pp-f-pop]')) return;
      closePopovers(null);
    });

    doc.addEventListener('keydown', function (event) {
      var key = event.key;
      /* role=button ბმულები (ჩიპები, „გასუფთავება“) Space-ითაც მუშაობს */
      if ((key === ' ' || key === 'Spacebar') && event.target && event.target.closest && event.target.closest('facet-remove a')) {
        event.preventDefault();
        event.target.click();
        return;
      }
      var drawer = $('pp-f-drawer');
      if (drawer && drawer.open && root.classList.contains('pp-f-lock')) {
        if (key === 'Escape') {
          event.preventDefault();
          closeDrawer(false);
          return;
        }
        if (key === 'Tab') trapTab(event, drawer);
        return;
      }
      if (key === 'Escape') {
        var openPop = doc.querySelector('#' + ROOT_ID + ' details[data-pp-f-pop][open]');
        if (openPop) {
          event.preventDefault();
          openPop.open = false;
          syncExpanded(openPop);
          var summary = openPop.querySelector(':scope > summary');
          if (summary) summary.focus();
        }
      }
    });

    window.addEventListener('popstate', function () {
      /* /search-ზე PP-ის ძებნის ძრავა ჩართულია (html.pp-sr-on): შედეგებს თვითონ ხატავს, native ბლოკი კი
         სამუდამოდ დამალულია — მის ხელახლა ჩამოტვირთვას აზრი არ აქვს */
      if (doc.documentElement.classList.contains('pp-sr-on')) return;
      /* წყარო ყოველთვის მისამართია (hash-ის ცვლილებაზეც state = null, ამიტომ state-ს არ ვენდობით) */
      var params = window.location.search.slice(1);
      if (params === FacetFiltersForm.searchParamsPrev) return;
      renderPage(params, { push: false });
    });

    /* bfcache-დან დაბრუნებისას (მაგ. მოდელის ბმულიდან „უკან“) ფურცელი დახურულია */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      var drawer = $('pp-f-drawer');
      state.drawerOpen = false;
      root.classList.remove('pp-f-lock');
      if (drawer) {
        drawer.classList.remove('is-closing');
        drawer.open = false;
        syncExpanded(drawer);
      }
      setLoading(false);
    });
  }

  /* ---------- მოძველებული გვერდი (?page=N ცარიელია, შედეგი კი არსებობს) ---------- */

  function fixStalePage() {
    var r = getRoot();
    if (!r) return;
    var staleUrl = r.getAttribute('data-pp-stale');
    if (staleUrl) {
      window.location.replace(staleUrl);
      return;
    }
    /* ძველი მარკაპის/ძებნის შემთხვევა: ბადეში ბარათი არ არის, რაოდენობა კი > 0 */
    var url = new URL(window.location.href);
    var page = parseInt(url.searchParams.get('page') || '1', 10);
    var total = parseInt(r.getAttribute('data-pp-total') || '0', 10);
    var grid = $('product-grid');
    if (page > 1 && total > 0 && grid && !grid.querySelector('.grid__item, li')) {
      url.searchParams.delete('page');
      window.location.replace(url.pathname + url.search + url.hash);
    }
  }

  /* ---------- custom elements (თავსებადობა) ---------- */

  class FacetFiltersForm extends HTMLElement {
    static renderPage(searchParams, event, updateURLHash) {
      renderPage(searchParams, { push: updateURLHash !== false });
    }

    static toggleActiveFacets(disable) {
      doc.querySelectorAll('#' + ROOT_ID + ' facet-remove a').forEach(function (el) {
        el.classList.toggle('disabled', disable !== false);
      });
    }

    static clearLoadingState() {
      setLoading(false);
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      var next = paramsFromHref(event.currentTarget.href);
      if (next) renderPage(next.params, { path: next.path });
    }
  }

  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  window.FacetFiltersForm = FacetFiltersForm;

  class FacetRemove extends HTMLElement {
    connectedCallback() {
      var link = this.querySelector('a');
      if (link && !link.hasAttribute('role')) link.setAttribute('role', 'button');
    }
  }
  customElements.define('facet-remove', FacetRemove);

  /* PP FIX #38: ფასი — მხოლოდ ციფრი და წერტილი, დიაპაზონში მოქცევა */
  class PriceRange extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ppBound) return;
      this.dataset.ppBound = '1';
      this.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('change', function () {
          PriceRange.normalize(input);
        });
      });
    }

    static normalize(input) {
      var value = normalizePrice(input.value);
      if (value === '') {
        input.value = '';
        return;
      }
      var num = Number(value);
      var min = Number(input.getAttribute('data-min'));
      var max = Number(input.getAttribute('data-max'));
      if (isFinite(min) && num < min) num = min;
      if (isFinite(max) && max > 0 && num > max) num = max;
      input.value = String(num);
    }
  }
  customElements.define('price-range', PriceRange);

  /* ტელეფონის შემობრუნება / ფანჯრის გაფართოება ≥750px: ფურცელი აღარ ჩანს — ვხურავთ, რომ გვერდი არ ჩაიკეტოს */
  function watchBreakpoint() {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 750px)');
    var onChange = function () {
      if (!mq.matches) return;
      var drawer = $('pp-f-drawer');
      state.drawerOpen = false;
      root.classList.remove('pp-f-lock');
      var r = getRoot();
      if (r) r.classList.remove('pp-f--drawer-shown');
      if (drawer && drawer.open) {
        drawer.classList.remove('is-closing');
        drawer.open = false;
        syncExpanded(drawer);
      }
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  function initAria() {
    doc.querySelectorAll('#' + ROOT_ID + ' details[data-pp-f-pop], #pp-f-drawer').forEach(syncExpanded);
  }

  bindGlobal();
  watchBreakpoint();
  initAria();
  fixStalePage();
  window.PPFacets = { renderPage: renderPage, closeDrawer: closeDrawer };
})();
